import React from "react"
class HtmlDataType extends React.Component{
  
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data) {
      return (
        <div id="html-data-type" dangerouslySetInnerHTML={{__html: this.props.data + `${this.props.data && this.props.data.length > 20 ? "..." : ''}`}}></div>
      );
    } else {
      return (
        <div><span className="none">{I18n.t('none')}</span></div>
      )
    }
  }

};

export default HtmlDataType